import { render } from "./GlobeIcon.vue?vue&type=template&id=5cbf499c"
import script from "./GlobeIcon.vue?vue&type=script&lang=js"
export * from "./GlobeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__